// extracted by mini-css-extract-plugin
export default {"helpIconNoLabel":"helpIconNoLabel---zdMBB","helpIcon":"helpIcon---QHX6W"};